<div class="container">
  <form
    id="routeForm"
    [formGroup]="routeForm"
    (ngSubmit)="routeForm.valid ? saveRouter(routeForm.value) : errorMessage()"
    enctype="multipart/form-data"
    style="overflow: auto"
  >
    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
      <div style="display: flex; width: 100%">
        <div style="flex: 10">
          <div class="first-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="name"
                  matInput
                  #nombre
                  maxlength="255"
                  placeholder="Nombre"
                  required
                />
                <mat-hint>{{ nombre.value.length }}/255</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Distancia aproximada en kilometros</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="distance"
                  #distance
                  [readonly]="true"
                  placeholder="Distancia aproximada en kilometros"
                />
                <mat-hint>{{ distance.value.length }}/10</mat-hint>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Tiempo aproximado en horas</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="timeHours"
                  #timeHours
                  [readonly]="true"
                  placeholder="Tiempo aproximado en horas"
                />
                <mat-hint>{{ timeHours.value.length }}/10</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Descripción</mat-label>
                <textarea
                  autocomplete="off"
                  type="text"
                  formControlName="description"
                  matInput
                  #description
                  maxlength="10000"
                  placeholder="Descripción"
                  required
                  class="min-rows-2 resizable-textarea"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="15"
                ></textarea>
                <mat-hint>{{ description.value.length }}/10000</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="flex: 0.2">
          <button
            mat-mini-fab
            color="warn"
            type="submit"
            [disabled]="mapComponent.markers.length < 2"
          >
            <mat-icon>save</mat-icon>
          </button>

          <button
            mat-mini-fab
            color="primary"
            (click)="back($event)"
            style="margin-top: 10px"
          >
            <mat-icon>reply</mat-icon>
          </button>

          <button
            mat-mini-fab
            color="primary"
            type="button"
            (click)="
              mapComponent.routerFinished
                ? mapComponent.clearRoute()
                : mapComponent.calculateRoute(false, routeForm.get('activateReverse').value === 1 ? true : false)
            "
            style="margin-top: 10px"
            matTooltip="{{
              mapComponent.routerFinished ? 'Editar Ruta' : 'Calcular Ruta'
            }}"
          >
            <mat-icon>{{
              mapComponent.routerFinished ? "edit" : "navigation"
            }}</mat-icon>
          </button>
        </div>
      </div>

      <div style="margin-top: 30px; flex: 12">
        <app-map
          #mapComponent
          [markers]="markers"
          (routerData)="getRouter($event)"
        ></app-map>
      </div>
    </cdk-virtual-scroll-viewport>
  </form>
</div>
